const headCells = [
  { id: "view", numeric: false, disablePadding: true, label: "" },
  { id: "date", numeric: false, disablePadding: true, label: "Date Created" },
  { id: "time", numeric: false, disablePadding: true, label: "Time Created" },
  { id: "name", numeric: false, disablePadding: false, label: "Customer Name" },
  {
    id: "quote number",
    numeric: true,
    disablePadding: false,
    label: "Quote Number",
  },
  {
    id: "job name",
    numeric: false,
    disablePadding: false,
    label: "Project Name",
  },
  {
    id: "po number",
    numeric: false,
    disablePadding: false,
    label: "PO Number",
  },
  {
    id: "num of units",
    numeric: true,
    disablePadding: false,
    label: "Items in Cart",
  },
  { id: "status", numeric: false, disablePadding: false, label: "Status" },
];

const headCellsManager = [
  { id: "view", numeric: false, disablePadding: true, label: "" },
  { id: "date", numeric: false, disablePadding: true, label: "Date Created" },
  { id: "time", numeric: false, disablePadding: true, label: "Time Created" },
  { id: "name", numeric: false, disablePadding: false, label: "Customer Name" },
  {
    id: "quote number",
    numeric: true,
    disablePadding: false,
    label: "Quote Number",
  },
  {
    id: "dealerRep",
    numeric: false,
    disablePadding: false,
    label: "Dealer Rep",
  },
  {
    id: "job name",
    numeric: false,
    disablePadding: false,
    label: "Project Name",
  },
  {
    id: "po number",
    numeric: false,
    disablePadding: false,
    label: "PO Number",
  },
  {
    id: "price",
    numeric: false,
    disablePadding: false,
    label: "Dealer Net Cost",
  },
  {
    id: "num of units",
    numeric: true,
    disablePadding: false,
    label: "Items in Cart",
  },
  { id: "status", numeric: false, disablePadding: false, label: "Status" },
];

const dealerOrderheadCells = [
  { id: "date", numeric: false, disablePadding: true, label: "Sign-Off Date" },
  { id: "name", numeric: false, disablePadding: false, label: "Customer Name" },
  {
    id: "quote number",
    numeric: true,
    disablePadding: false,
    label: "Quote Number",
  },
  {
    id: "job name",
    numeric: false,
    disablePadding: false,
    label: "Project Name",
  },
  {
    id: "po number",
    numeric: false,
    disablePadding: false,
    label: "PO Number",
  },
  {
    id: "num of units",
    numeric: true,
    disablePadding: false,
    label: "Items in Cart",
  },
  { id: "status", numeric: false, disablePadding: false, label: "Status" },
];

const managerOrderheadCells = [
  { id: "date", numeric: false, disablePadding: true, label: "Sign-Off Date" },
  { id: "name", numeric: false, disablePadding: false, label: "Customer Name" },
  {
    id: "quote number",
    numeric: true,
    disablePadding: false,
    label: "Quote Number",
  },
  {
    id: "dealerRep",
    numeric: false,
    disablePadding: false,
    label: "Dealer Rep",
  },
  {
    id: "job name",
    numeric: false,
    disablePadding: false,
    label: "Project Name",
  },
  {
    id: "po number",
    numeric: false,
    disablePadding: false,
    label: "PO Number",
  },
  {
    id: "price",
    numeric: false,
    disablePadding: false,
    label: "Dealer Net Cost",
  },
  {
    id: "num of units",
    numeric: true,
    disablePadding: false,
    label: "Items in Cart",
  },
  { id: "status", numeric: false, disablePadding: false, label: "Status" },
];

const headCellsOrder = [
  { id: "view", numeric: false, disablePadding: true, label: "" },
  { id: "date", numeric: false, disablePadding: false, label: "Sign-Off Date" },
  { id: "downloadOrder", numeric: false, disablePadding: true, label: "Order" },
  { id: "name", numeric: false, disablePadding: false, label: "Customer Name" },
  {
    id: "quote number",
    numeric: true,
    disablePadding: false,
    label: "Quote Number",
  },
  {
    id: "downloadProd",
    numeric: false,
    disablePadding: true,
    label: "Production",
  },
  { id: "dealer", numeric: false, disablePadding: false, label: "Dealer" },
  {
    id: "dealer rep",
    numeric: false,
    disablePadding: false,
    label: "Dealer Rep",
  },
  {
    id: "po number",
    numeric: false,
    disablePadding: false,
    label: "PO Number",
  },
  { id: "so number", numeric: false, disablePadding: false, label: "SO #" },
  {
    id: "invoice number",
    numeric: false,
    disablePadding: false,
    label: "Invoice #",
  },
  {
    id: "dealer cost",
    numeric: true,
    disablePadding: false,
    label: "Dealer Net Cost",
  },
  {
    id: "num of units",
    numeric: true,
    disablePadding: false,
    label: "Items in Cart",
  },
  { id: "status", numeric: false, disablePadding: false, label: "Status" },
];

const headCellsAdmin = [
  { id: "view", numeric: false, disablePadding: true, label: "" },
  { id: "download", numeric: false, disablePadding: true, label: "Quote" },
  { id: "date", numeric: false, disablePadding: false, label: "Date Created" },
  { id: "time", numeric: false, disablePadding: false, label: "Time Created" },
  { id: "name", numeric: false, disablePadding: false, label: "Customer Name" },
  {
    id: "quote number",
    numeric: true,
    disablePadding: false,
    label: "Quote Number",
  },
  { id: "dealer", numeric: false, disablePadding: false, label: "Dealer" },
  {
    id: "dealer rep",
    numeric: false,
    disablePadding: false,
    label: "Dealer Rep",
  },
  {
    id: "po number",
    numeric: false,
    disablePadding: false,
    label: "PO Number",
  },
  {
    id: "dealer cost",
    numeric: true,
    disablePadding: false,
    label: "Dealer Net Cost",
  },
  {
    id: "num of units",
    numeric: true,
    disablePadding: false,
    label: "Items in Cart",
  },
  { id: "status", numeric: false, disablePadding: false, label: "Status" },
];

const outsideSalesHeadOrder = [
  { id: "date", numeric: false, disablePadding: false, label: "Sign-Off Date" },
  { id: "downloadOrder", numeric: false, disablePadding: true, label: "Order" },
  { id: "name", numeric: false, disablePadding: false, label: "Customer Name" },
  {
    id: "quote number",
    numeric: true,
    disablePadding: false,
    label: "Quote Number",
  },
  { id: "dealer", numeric: false, disablePadding: false, label: "Dealer" },
  {
    id: "dealer rep",
    numeric: false,
    disablePadding: false,
    label: "Dealer Rep",
  },
  {
    id: "po number",
    numeric: false,
    disablePadding: false,
    label: "PO Number",
  },
  {
    id: "so number",
    numeric: false,
    disablePadding: false,
    label: "SO #",
  },
  {
    id: "dealer cost",
    numeric: true,
    disablePadding: false,
    label: "Dealer Net Cost",
  },
  {
    id: "num of units",
    numeric: true,
    disablePadding: false,
    label: "Items in Cart",
  },
  { id: "status", numeric: false, disablePadding: false, label: "Status" },
];

const outsideSalesHead = [
  { id: "view", numeric: false, disablePadding: true, label: "" },
  { id: "download", numeric: false, disablePadding: true, label: "Quote" },
  { id: "date", numeric: false, disablePadding: false, label: "Date Created" },
  { id: "time", numeric: false, disablePadding: false, label: "Time Created" },
  { id: "name", numeric: false, disablePadding: false, label: "Customer Name" },
  {
    id: "quote number",
    numeric: true,
    disablePadding: false,
    label: "Quote Number",
  },
  { id: "dealer", numeric: false, disablePadding: false, label: "Dealer" },
  {
    id: "dealer rep",
    numeric: false,
    disablePadding: false,
    label: "Dealer Rep",
  },
  {
    id: "po number",
    numeric: false,
    disablePadding: false,
    label: "PO Number",
  },
  {
    id: "dealer cost",
    numeric: true,
    disablePadding: false,
    label: "Dealer Net Cost",
  },
  {
    id: "num of units",
    numeric: true,
    disablePadding: false,
    label: "Items in Cart",
  },
  { id: "status", numeric: false, disablePadding: false, label: "Status" },
];

const headCellsCompanyManager = [
  { id: "view", numeric: false, disablePadding: true, label: "" },
  { id: "date", numeric: false, disablePadding: true, label: "Date Created" },
  { id: "time", numeric: false, disablePadding: true, label: "Time Created" },
  { id: "name", numeric: false, disablePadding: false, label: "Customer Name" },
  {
    id: "quote number",
    numeric: true,
    disablePadding: false,
    label: "Quote Number",
  },
  { id: "dealer", numeric: false, disablePadding: false, label: "Dealer" },
  {
    id: "dealerRep",
    numeric: false,
    disablePadding: false,
    label: "Dealer Rep",
  },
  {
    id: "job name",
    numeric: false,
    disablePadding: false,
    label: "Project Name",
  },
  {
    id: "po number",
    numeric: false,
    disablePadding: false,
    label: "PO Number",
  },
  {
    id: "price",
    numeric: false,
    disablePadding: false,
    label: "Dealer Net Cost",
  },
  {
    id: "num of units",
    numeric: true,
    disablePadding: false,
    label: "Items in Cart",
  },
  { id: "status", numeric: false, disablePadding: false, label: "Status" },
];

const companyManagerOrderheadCells = [
  { id: "date", numeric: false, disablePadding: true, label: "Sign-Off Date" },
  { id: "name", numeric: false, disablePadding: false, label: "Customer Name" },
  {
    id: "quote number",
    numeric: true,
    disablePadding: false,
    label: "Quote Number",
  },
  { id: "dealer", numeric: false, disablePadding: false, label: "Dealer" },
  {
    id: "dealerRep",
    numeric: false,
    disablePadding: false,
    label: "Dealer Rep",
  },
  {
    id: "job name",
    numeric: false,
    disablePadding: false,
    label: "Project Name",
  },
  {
    id: "po number",
    numeric: false,
    disablePadding: false,
    label: "PO Number",
  },
  {
    id: "price",
    numeric: false,
    disablePadding: false,
    label: "Dealer Net Cost",
  },
  {
    id: "num of units",
    numeric: true,
    disablePadding: false,
    label: "Items in Cart",
  },
  { id: "status", numeric: false, disablePadding: false, label: "Status" },
];

const productionHeadCells = [
  {
    id: "downloadLabel",
    numeric: false,
    disablePadding: false,
    label: "Production",
  },
  {
    id: "quote number",
    numeric: true,
    disablePadding: false,
    label: "Quote Number",
  },
  { id: "dealer", numeric: false, disablePadding: false, label: "Dealer" },
  {
    id: "dealer rep",
    numeric: false,
    disablePadding: false,
    label: "Dealer Rep",
  },
  {
    id: "po number",
    numeric: false,
    disablePadding: false,
    label: "PO Number",
  },
  {
    id: "so number",
    numeric: false,
    disablePadding: false,
    label: "SO Number",
  },
  {
    id: "num of units",
    numeric: true,
    disablePadding: false,
    label: "Items in Cart",
  },
  { id: "status", numeric: false, disablePadding: false, label: "Status" },
];

const headCellsInsights = [
  { id: "view", numeric: false, disablePadding: true, label: "" },
  {
    id: "dateCreated",
    numeric: false,
    disablePadding: true,
    label: "Date Created",
  },
  { id: "date", numeric: false, disablePadding: false, label: "Sign-Off Date" },
  { id: "downloadOrder", numeric: false, disablePadding: true, label: "PDF" },
  { id: "name", numeric: false, disablePadding: false, label: "Customer Name" },
  {
    id: "quote number",
    numeric: true,
    disablePadding: false,
    label: "Quote Number",
  },
  { id: "dealer", numeric: false, disablePadding: false, label: "Dealer" },
  {
    id: "dealer rep",
    numeric: false,
    disablePadding: false,
    label: "Dealer Rep",
  },
  {
    id: "po number",
    numeric: false,
    disablePadding: false,
    label: "PO Number",
  },
  { id: "so number", numeric: false, disablePadding: false, label: "SO #" },
  {
    id: "invoice number",
    numeric: false,
    disablePadding: false,
    label: "Invoice #",
  },
  {
    id: "dealer cost",
    numeric: true,
    disablePadding: false,
    label: "Dealer Net Cost",
  },
  {
    id: "num of units",
    numeric: true,
    disablePadding: false,
    label: "Items in Cart",
  },
  { id: "daysToClose", numeric: false, disablePadding: true, label: "Timing" },
  { id: "status", numeric: false, disablePadding: false, label: "Status" },
];

const headCellsInsightsOutsideSales = [
  { id: "view", numeric: false, disablePadding: true, label: "" },
  {
    id: "dateCreated",
    numeric: false,
    disablePadding: true,
    label: "Date Created",
  },
  { id: "date", numeric: false, disablePadding: false, label: "Sign-Off Date" },
  { id: "downloadOrder", numeric: false, disablePadding: true, label: "PDF" },
  { id: "name", numeric: false, disablePadding: false, label: "Customer Name" },
  {
    id: "quote number",
    numeric: true,
    disablePadding: false,
    label: "Quote Number",
  },
  { id: "dealer", numeric: false, disablePadding: false, label: "Dealer" },
  {
    id: "dealer rep",
    numeric: false,
    disablePadding: false,
    label: "Dealer Rep",
  },
  {
    id: "po number",
    numeric: false,
    disablePadding: false,
    label: "PO Number",
  },
  { id: "so number", numeric: false, disablePadding: false, label: "SO #" },
  {
    id: "dealer cost",
    numeric: true,
    disablePadding: false,
    label: "Dealer Net Cost",
  },
  {
    id: "num of units",
    numeric: true,
    disablePadding: false,
    label: "Items in Cart",
  },
  { id: "daysToClose", numeric: false, disablePadding: true, label: "Timing" },
  { id: "status", numeric: false, disablePadding: false, label: "Status" },
];

export {
  headCells,
  headCellsAdmin,
  headCellsCompanyManager,
  headCellsInsights,
  headCellsInsightsOutsideSales,
  headCellsManager,
  headCellsOrder,
  productionHeadCells,
  companyManagerOrderheadCells,
  dealerOrderheadCells,
  managerOrderheadCells,
  outsideSalesHeadOrder,
  outsideSalesHead,
};
